import { motion } from "framer-motion";
import { useSite, UI } from "@/lib/site";
import { CLIENT_LOGOS } from "@/lib/content";
import { MaskLine, Reveal } from "@/components/Reveal";

export const Clients = () => {
  const { t, content } = useSite();
  const stat = Array.isArray(content?.stats) ? content.stats[1] : null;
  return (
    <section data-testid="clients-section" className="grain relative overflow-hidden bg-[#0e0c0a] px-5 py-24 text-[#f6ecd9] md:px-10 md:py-36">
      <div className="relative mx-auto max-w-[1400px]">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow !text-[#e6ca7a]">{t(UI.clients)}</p>
            <h2 className="font-display mt-6 text-4xl font-medium leading-[1.02] sm:text-5xl lg:text-6xl">
              <MaskLine inView>{t(UI.clients)}</MaskLine>
            </h2>
          </div>
          <Reveal className="lg:col-span-5">
            <p className="text-base leading-relaxed text-[#d8ccb6] md:text-lg">{t(UI.clientsLead)}</p>
          </Reveal>
        </div>
        <div className="mt-16 grid grid-cols-2 border-l border-t border-[#e6ca7a]/15 sm:grid-cols-3 lg:grid-cols-6">
          {CLIENT_LOGOS.map((src, i) => (
            <motion.div
              key={src}
              className="group flex h-28 items-center justify-center border-b border-r border-[#e6ca7a]/15 px-4 transition-colors duration-500 hover:bg-[#1c1712] md:h-36"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, delay: (i % 6) * 0.05 }}
              data-testid={`client-logo-${i}`}
            >
              <img src={src} alt="client logo" loading="lazy" className="max-h-12 max-w-[82%] object-contain opacity-75 transition-[opacity,transform] duration-500 group-hover:scale-105 group-hover:opacity-100 md:max-h-14" />
            </motion.div>
          ))}
          <div className="col-span-2 flex flex-col items-start justify-center gap-1 border-b border-r border-[#e6ca7a]/15 bg-gradient-to-br from-[#2a2015] to-[#0e0c0a] px-6 py-6 sm:col-span-1 lg:col-span-4 lg:flex-row lg:items-center lg:gap-6" data-testid="clients-stat-cell">
            <span className="font-display gold-text text-5xl md:text-6xl">{stat?.value}{stat?.suffix}</span>
            <span className="text-sm text-[#d8ccb6]">{t(stat?.label)}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
